/** @jsxImportSource @emotion/react */
'use memo'

import React from 'react'
import { useHistory } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import Icon from '../../../../components/Icon'
import { headerRowStyle, headerTitleStyle, headerLinkStyle } from './styles'

const HighlightWidgetHeader: React.FC = () => {
  const history = useHistory()

  const handleViewAll = () => {
    history.push(ROUTES.PROFILE.HIGHLIGHTS)
  }

  return (
    <div css={headerRowStyle}>
      <div css={headerTitleStyle}>
        <Icon name='film' fontSize={20} color={colors.WHITE} />
        Your Latest Highlights
      </div>
      <button type='button' css={headerLinkStyle} onClick={handleViewAll}>
        All Highlights
        <Icon name='chevron-right' fontSize={12} color={colors.PRIMARY} />
      </button>
    </div>
  )
}

export default HighlightWidgetHeader
